import { createGettext } from 'vue3-gettext';
import translations from '@/i18n/translations.json';

export default createGettext({
  availableLanguages: {
    en: 'English',
    de: 'Deutsch',
  },
  defaultLanguage: 'en',
  translations,
});
